module.exports = __webpack_public_path__ + "img/3_2023-04-20--TERRY-FOX-Duo-long-men.fc35c5e2.jpg";